import { copyText } from 'src/constants/copy/copy.utils';

/** @type {import('./copy.utils').CopyEntry} */
export const UPDATE_ROLE_AND_PERMISSIONS_ACTION = {
    defaultMessage: 'Update Role & Permissions',
    id: 'TEAM.ACTION.UPDATE_ROLE_AND_PERMISSIONS',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRANSFER_OWNERSHIP_ACTION = {
    defaultMessage: 'Transfer Ownership',
    id: 'TEAM.ACTION.TRANSFER_OWNERSHIP',
};

/** @type {import('./copy.utils').CopyEntry} */
export const REVOKE_INVITATION_ACTION = {
    defaultMessage: 'Revoke Invitation',
    id: 'TEAM.ACTION.REVOKE_INVITATION',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRANSFER_OWNERSHIP_MODAL_TITLE = {
    defaultMessage: 'Transfer Ownership',
    id: 'TEAM.MODAL.TRANSFER_OWNERSHIP.TITLE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRANSFER_OWNERSHIP_NEW_OWNER_EMAIL_LABEL = {
    defaultMessage: 'New owner email',
    id: 'TEAM.MODAL.TRANSFER_OWNERSHIP.NEW_OWNER_EMAIL_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRANSFER_OWNERSHIP_EMAIL_REQUIRED_ERROR = {
    defaultMessage: 'Email address is required.',
    id: 'TEAM.MODAL.TRANSFER_OWNERSHIP.EMAIL_REQUIRED_ERROR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRANSFER_OWNERSHIP_EMAIL_INVALID_ERROR = {
    defaultMessage: 'Enter a valid email address.',
    id: 'TEAM.MODAL.TRANSFER_OWNERSHIP.EMAIL_INVALID_ERROR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRANSFER_OWNERSHIP_SAME_OWNER_ERROR = {
    defaultMessage: 'Choose a different team member to receive ownership.',
    id: 'TEAM.MODAL.TRANSFER_OWNERSHIP.SAME_OWNER_ERROR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const EDIT_ROLE_AGENCY_OWNER_USE_TRANSFER_OWNERSHIP = {
    defaultMessage: 'To assign agency ownership, use the Transfer Ownership action on the current Agency Owner row.',
    id: 'TEAM.MODAL.EDIT_ROLE.AGENCY_OWNER_USE_TRANSFER_OWNERSHIP',
};

export const getUpdateRoleAndPermissionsLabel = () => copyText(UPDATE_ROLE_AND_PERMISSIONS_ACTION);

export const getTransferOwnershipLabel = () => copyText(TRANSFER_OWNERSHIP_ACTION);

export const getRevokeInvitationLabel = () => copyText(REVOKE_INVITATION_ACTION);

export const getTransferOwnershipModalTitle = () => copyText(TRANSFER_OWNERSHIP_MODAL_TITLE);

export const getTransferOwnershipNewOwnerEmailLabel = () => copyText(TRANSFER_OWNERSHIP_NEW_OWNER_EMAIL_LABEL);

export const getTransferOwnershipEmailRequiredError = () => copyText(TRANSFER_OWNERSHIP_EMAIL_REQUIRED_ERROR);

export const getTransferOwnershipEmailInvalidError = () => copyText(TRANSFER_OWNERSHIP_EMAIL_INVALID_ERROR);

export const getTransferOwnershipSameOwnerError = () => copyText(TRANSFER_OWNERSHIP_SAME_OWNER_ERROR);

export const getEditRoleAgencyOwnerUseTransferOwnershipMessage = () => (
    copyText(EDIT_ROLE_AGENCY_OWNER_USE_TRANSFER_OWNERSHIP)
);
